module.exports = __webpack_public_path__ + "fonts/Baloo2-SemiBold.ff177ef.ttf";